import { Form } from "@/components/form";
import { ArticuloTransferenciaTipo } from "@/shared/types/articulo-transferencia";
import { Stack } from "@mui/material";

export default function ArticuloTransferenciaGeneralInfoFields() {
    return <Stack gap={2} direction={"row"} flexWrap={"wrap"}>
        <Stack flex={"1 1 150px"}>
            <Form.Select name="tipo" label="Tipo" size="small" >
                <Form.Select.Option value={ArticuloTransferenciaTipo.Envio}>Envío</Form.Select.Option>
                <Form.Select.Option value={ArticuloTransferenciaTipo.Recepcion}>Recepción</Form.Select.Option>
            </Form.Select>
        </Stack>
        <Stack flex={"1 1 auto"}>
            <Form.DatePicker name="fecha" label="Fecha" size="small" />
        </Stack>
        <Stack flex={"5 1 auto"} />
    </Stack>
}